var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-10 legenda text-right" }, [
          _c("strong", { staticClass: "text-primary" }, [_vm._v(" Ítens: ")]),
          _vm._v(_vm._s(_vm.qtdItens) + "\n      "),
          _c("strong", { staticClass: "text-primary" }, [
            _vm._v("| Produtos: ")
          ]),
          _vm._v(" " + _vm._s(_vm.qtdProdutos) + "\n      "),
          _c("strong", { staticClass: "text-primary" }, [_vm._v(" | Total: ")]),
          _vm._v(" R$ " + _vm._s(_vm.valorTotal) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { attrs: { "align-v": "end" } },
            [
              _c(
                "b-col",
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Produto")]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["##########"],
                        expression: "['##########']"
                      }
                    ],
                    attrs: { placeholder: "Código" },
                    on: {
                      keyup: [
                        _vm.searchProduto,
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.changeFocusToQuantidade.apply(
                            null,
                            arguments
                          )
                        }
                      ]
                    },
                    model: {
                      value: _vm.codigo,
                      callback: function($$v) {
                        _vm.codigo = $$v
                      },
                      expression: "codigo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", [
                _c("label", { attrs: { for: "quantidade-produtos" } }, [
                  _vm._v("Quantidade:")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "######",
                      expression: "'######'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.quantidade,
                      expression: "quantidade"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "quantidade-produtos", type: "text" },
                  domProps: { value: _vm.quantidade },
                  on: {
                    focus: _vm.blurQuantidade,
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.saveEstoque(false)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.quantidade = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.saveEstoque(false)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus-circle" }),
                      _vm._v("\n          Adicionar")
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticStyle: { height: "30px" } },
            [
              _c("b-col", [
                _c("small", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.labelProduto.length > 0 ? _vm.labelProduto : ""
                      ) +
                      "\n        "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "col-md-4" },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "filter-input",
                          type: "search",
                          placeholder: "Buscar item no estoque"
                        },
                        model: {
                          value: _vm.filter,
                          callback: function($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: !_vm.filter },
                              on: {
                                click: function($event) {
                                  _vm.filter = ""
                                }
                              }
                            },
                            [_vm._v("Limpar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.exportar()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-file-excel" }),
                      _vm._v(" Exportar Estoque")
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-table", {
                    staticClass: "mt-3",
                    attrs: {
                      items: _vm.dataComputed,
                      fields: _vm.colunas,
                      "current-page": _vm.currentPage,
                      "per-page": _vm.perPage,
                      filter: _vm.filter,
                      "filter-included-fields": _vm.filterOn,
                      "show-empty": "",
                      small: "",
                      hover: "",
                      responsive: ""
                    },
                    on: { filtered: _vm.onFiltered },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(botao)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary", title: "Editar" },
                                on: {
                                  click: function($event) {
                                    return _vm.edit(row.item.codigo)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-edit" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: { variant: "danger", title: "Deletar " },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteItemEstoque(
                                      row.item.codigo
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-trash" })]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center"
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row p-3" }, [
            _c(
              "div",
              { staticClass: "col-md-12 mt-2 text-right" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "danger", size: "sm" },
                    on: { click: _vm.deleteEstoque }
                  },
                  [
                    _c("i", { staticClass: "fas fa-eraser" }),
                    _vm._v(" Limpar Estoque\n        ")
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: _vm.labelProduto },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalEstoque = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalEstoque,
            callback: function($$v) {
              _vm.modalEstoque = $$v
            },
            expression: "modalEstoque"
          }
        },
        [
          _c("b-card", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("strong", [_vm._v("Estoque Atual: ")]),
                _vm._v(
                  " " + _vm._s(_vm.estoque[_vm.codigo]) + " unidades\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-12" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Quantidade")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "######",
                      expression: "'######'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.quantidade,
                      expression: "quantidade"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.quantidade },
                  on: {
                    focus: _vm.searchProduto,
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.addEstoque.apply(null, arguments)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.quantidade = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 text-center container-btn" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.saveEstoque(false)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus-circle" }),
                      _vm._v("\n            Adicionar")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "warning", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.saveEstoque(true)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-minus-circle" }),
                      _vm._v("\n            Remover")
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 text-left" }, [
      _c("h3", [_vm._v("Estoque")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-666dd8a7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666dd8a7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/estoque/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-666dd8a7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/estoque/Main.vue
// module chunks = 2